import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { HttpServiceCustomer } from "src/app/services/Customer/http/http.service_Customer";
import { CustCard_2 } from "src/classes/Customers/CustCard_2";
import { HttpServiceAccount } from "src/app/services/Authorization/http/http.service_Account";
import { screenId } from "src/environments/environment";
import { Control } from "src/classes/Authorization/BusinessRole";
import { CustomerIn } from "src/classes/Customers/CustCard_1";
import { CustCardTabService } from "src/app/services/Custcard/cust-card-tab/cust-card-tab.service";
import { CustCard_3 } from "src/classes/Customers/CustCard_3";
import { Router } from "@angular/router";
import { ControlsService } from "src/app/services/Common/controls.service";
import { NGXLogger } from "ngx-logger";

@Component({
    selector: "app-custcardview2",
    templateUrl: "./custcardview2.component.html",
    styleUrls: ["./custcardview2.component.css"],
    providers: [HttpServiceCustomer, HttpServiceAccount]
})

export class Custcardview2Component implements OnInit {
    @Input() customerId: number = 0;
    @Input() custcard_3: CustCard_3 = new CustCard_3();
    @Output() openSmsDialog: EventEmitter<void> = new EventEmitter<void>();

    customCustCard_2: CustCard_2[];
    controls: Control[];
    tmpcontrols: Control[];
    customerin: CustomerIn = new CustomerIn();

    finalArray = [];
    iconArray: { cb_id: number, icon: string }[] = [
        { cb_id: 42, icon: "icon fa-vial" },
        { cb_id: 43, icon: "icon fa-paw" },
        { cb_id: 44, icon: "icon icon-ticket" },
        { cb_id: 45, icon: "icon fa-images" },
        { cb_id: 46, icon: "icon fa-calendar-clock" },
        { cb_id: 47, icon: "icon fa-address-card" },
        { cb_id: 48, icon: "icon fa-cash-register" },
        { cb_id: 49, icon: "icon fa-paperclip" },
        { cb_id: 50, icon: "icon fa-message-smile" },
        { cb_id: 51, icon: "icon fa-briefcase-medical" },
        { cb_id: 57, icon: "icon fa-user" },
    ];

    navbarOpened: boolean = false;
    moreOpened: boolean = false;
    communicationOpened: boolean = false;
    backgroundVisible: boolean = false;

    constructor(
        private httpServiceCustomer: HttpServiceCustomer,
        private httpServiceAccount: HttpServiceAccount,
        private router: Router,
        private custCardTabService: CustCardTabService,
        private controlsService: ControlsService,
        private logger: NGXLogger
    ) { }

    ngOnInit() {
        this.customerin.customer_id = this.customerId;

        // Get the list of control states
        this.httpServiceAccount.getControlsByScreen({ screen_id: screenId.Customers.custcardview })
            .subscribe((res: [Control]) => {
                this.controls = res;
                console.log("controls count of view2: " + this.controls.length);

                //get custcard_2 data
                this.httpServiceCustomer.getCustCard_2(this.customerin)
                    .subscribe((res: CustCard_2[]) => {
                        this.customCustCard_2 = res;
                        console.log("count items in customCustCard_2: " + this.customCustCard_2.length);

                        console.log("controls: ", this.controls);
                        console.log("customCustCard_2: ", this.customCustCard_2);

                        if (this.controls !== undefined && this.customCustCard_2 !== undefined) {
                            this.controlsService.custcardviewControlsData = this.controls.filter(x => x.cb_ctrl_type !== 10)

                            this.createFinalArray();

                            if (this.finalArray.length > 0) {
                                let userRole = parseInt(sessionStorage.getItem("userRole"));
                                this.finalArray = this.finalArray.filter(q => q.cb_is_visible_role <= userRole).reverse();
                                console.log("count finalArray of tabs: " + this.finalArray.length);
                            }

                            let custcardTabviewId = [];
                            this.finalArray.forEach(item => custcardTabviewId.push(item.cb_id));
                            sessionStorage.setItem("custcardTabviewId", JSON.stringify(custcardTabviewId));
                        }
                    }, error => {
                        console.log(error);
                        this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                    });
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    createFinalArray(): void {
        this.tmpcontrols = this.controls.filter(x => x.cb_ctrl_type === 10);
        this.tmpcontrols.map(s1 => {
            this.finalArray.push({
                cb_id: s1.cb_id,
                title: this.customCustCard_2.find(s2 => s2.cb_id === s1.cb_id).title,
                isHaveValue: this.customCustCard_2.find(s2 => s2.cb_id === s1.cb_id).isHaveValue,
                cb_is_visible_role: this.tmpcontrols.find(s2 => s2.cb_id === s1.cb_id).cb_is_visible_role,
                icon: this.iconArray.find(s2 => s2.cb_id === s1.cb_id).icon
            });
        });
    }

    backgroundHide(): void {
        this.backgroundVisible = false;
        this.navbarOpened = false;
        this.moreOpened = false;
        this.communicationOpened = false;
    }

    footerOpen(item: number): void {
        if (item == 1) {
            if (this.navbarOpened == false) {
                this.moreOpened = false;
                this.communicationOpened = false;
                this.navbarOpened = true;
                this.backgroundVisible = true;
            } else {
                this.navbarOpened = false;
                this.backgroundVisible = false;
            }
        } else if (item == 2) {
            if (this.moreOpened == false) {
                this.navbarOpened = false;
                this.communicationOpened = false;
                this.moreOpened = true;
                this.backgroundVisible = true;
            } else {
                this.moreOpened = false;
                this.backgroundVisible = false;
            }
        } else if (item == 3) {
            if (this.communicationOpened == false) {
                this.navbarOpened = false;
                this.moreOpened = false;
                this.communicationOpened = true;
                this.backgroundVisible = true;
            } else {
                this.communicationOpened = false;
                this.backgroundVisible = false;
            }
        }
        console.log(item, this.navbarOpened)
    }

    openEditCustomer(): void {
        this.router.navigate(["clients", "editpersonal", this.customerin.customer_id]);
    }

    handleChange(event: { originalEvent: PointerEvent, index: number }): void {
        console.log("Index is:", event.index);
        let custcardTabviewId = JSON.parse(sessionStorage.getItem("custcardTabviewId"));
        this.custCardTabService.tabTitle = this.finalArray.find(item => item.cb_id == custcardTabviewId[event.index]).title;
        this.custCardTabService.tabIndex = custcardTabviewId[event.index];
        this.backgroundHide();
    }

    getWhatsAppLink(): string {
        if (this.custcard_3 && this.custcard_3.pelephone && this.custcard_3.pelephone.length == 10) {
            return "https://wa.me/+972" + this.custcard_3.pelephone.slice(1);
        }
    }

    openDialog(): void {
        this.openSmsDialog.emit();
    }

    // Check if the control with the given id is disabled for the user by his role
    isDisabled(id: number): boolean {
        if (this.controlsService.custcardviewControlsData) {
            let control = this.controlsService.custcardviewControlsData.find(control => control.cb_id == id);
            if (!control) {
                return false;
            }
            let enabledRole = control.cb_is_enabled_role;
            let userRole = sessionStorage.getItem("userRole");
            return +userRole < +enabledRole;
        }
    }
} 